import { DpinUtilityBand } from './components/dpin-utility-band';
import { TheHero } from './components/hero';
import { TheMarketList } from './components/market-list';
import { TrendingNow } from './components/trending-now';
import { FEEDBACK_LINK } from '@/client/confs/app';
import { getScrollBehavior, getSearchParam } from '@/client/utils/dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const TheHomePage = () => {
  const { t } = useTranslation(['home']);

  // Header "Markets" link (no standalone /markets route) navigates here with
  // ?scrollTo=market-list when clicked from another page; consume it once on
  // mount and clean the URL so back/refresh doesn't re-trigger the scroll.
  useEffect(() => {
    if (getSearchParam('scrollTo') !== 'market-list') return;
    window.history.replaceState({}, '', '/');
    // Async sections above the list keep expanding after mount and undo a
    // single early scroll -- re-anchor a few times until layout settles.
    let tries = 0;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const attempt = () => {
      document.querySelector('#market-list')?.scrollIntoView({ behavior: getScrollBehavior(), block: 'start' });
      if (++tries < 3) timer = setTimeout(attempt, 500);
    };
    requestAnimationFrame(attempt);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="w-full pb-18 md:pb-14 min-h-full">
      <div className="max-w-[1400px] mx-auto">
        {/* Redesign (dpin-redesign-design.md §5): hero replaces the promo
            banner carousel at the top of the page. */}
        <TheHero />
        <TrendingNow />
        <DpinUtilityBand />
        <div id="market-list">
          <div className="neon-sechead px-4 md:px-6 pt-6">
            <div>
              <h2>{t('browse-markets', 'Browse markets')}</h2>
              <p>{t('browse-markets-sub', 'Open markets across every category.')}</p>
            </div>
          </div>
          <TheMarketList />
        </div>
        <p className="text-center text-sm text-muted-foreground py-12 px-4">
          {t('no-predictions-of-interest')}
          {FEEDBACK_LINK && (
            <>
              {' '}
              <a
                href={FEEDBACK_LINK}
                target="_blank"
                rel="noreferrer"
                className="underline hover:text-primary transition-colors"
              >
                {t('send-us-feedback')}
              </a>
            </>
          )}
        </p>
      </div>
    </section>
  );
};

export default TheHomePage;
